module.exports = __webpack_public_path__ + "static/media/IMG_1270.e44eef9b.jpg";